import { recordHeartbeat } from "./endpoints";

export { service } from "./endpoints";
export { HEARTBEAT_INTERVAL_SECONDS, RecordHeartbeatBody, UserAgentHints } from "./schemas";

export const contract = {
  heartbeats: { create: recordHeartbeat },
} as const;
